import {Component, input, ChangeDetectionStrategy} from "@angular/core"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-button",
    templateUrl: "./button.component.html",
    styleUrls: ["./button.component.scss"],
    host: {"[class.cm-save-button]": "$styling() === 'save'", "[class.cm-disabled]": "$disabled()"},
})
export class ButtonComponent {
    readonly $disabled = input(false, {alias: "disabled"})
    readonly $styling = input<"default" | "save">("default", {alias: "styling"})
}
